import { SagaIterator } from 'redux-saga';
import { put, select, takeLatest } from 'redux-saga/effects';
import { App, Produktlinie } from '@ps20-frontend/frontend-models';
import { Produktlinienname } from '@ps20/bff-models';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { selectVorschaedenUeberschritten } from '../../app/shared/selectors/vorschaeden.selector';
import { ThhHundActions } from '../thhHundActions';
import { selectProduktlinien } from '../../app/shared/selectors/produkt.selector';

export function* watchProduktlinienSaga(): SagaIterator {
  yield takeLatest(
    ThhHundActions.VORSCHAEDEN_VORHANDEN,
    safeSaga(updateProduktlinienStatus, App.THH_HUND),
  );
  yield takeLatest(
    ThhHundActions.VORSCHADEN_VALUE_CHANGED,
    safeSaga(updateProduktlinienStatus, App.THH_HUND),
  );
}

export function* updateProduktlinienStatus(): SagaIterator {
  const vorschaedenUeberschritten: boolean = yield select(selectVorschaedenUeberschritten);
  const produktlinien = yield select(selectProduktlinien);

  toggleProduktlinienActiveState(produktlinien);
  if (vorschaedenUeberschritten) {
    updateProduktlinienDeactivationStatus(
      produktlinien,
      true,
      Produktlinienname.BASIS,
      Produktlinienname.SMART,
    );
  }
  updateSelectedProduktlinie(produktlinien);
  const changeProduktlinienAction = new ThhHundActions().produktlinienChanged(produktlinien);
  yield put(changeProduktlinienAction);
}

function toggleProduktlinienActiveState(produktlinien: Produktlinie[]) {
  produktlinien.forEach(produktlinie => (produktlinie.deactivated = false));
}

function updateProduktlinienDeactivationStatus(
  produktlinien: Produktlinie[],
  deactivated: boolean,
  ...produktLines: Produktlinienname[]
) {
  produktlinien.forEach(tarifItem => {
    if (produktLines.includes(tarifItem.produktName)) {
      tarifItem.deactivated = deactivated;
    }
  });
}

function updateSelectedProduktlinie(produktlinien: Produktlinie[]) {
  const invalidProduktline = produktlinien.find(
    produktlinie => produktlinie.deactivated && produktlinie.selected,
  );
  const selectedProduktline = produktlinien.find(
    produktlinie => !produktlinie.deactivated && produktlinie.selected,
  );

  if (invalidProduktline != null) {
    invalidProduktline.selected = false;
  }
  if (selectedProduktline == null) {
    const activatedProduktlinien = produktlinien.filter(produktlinie => !produktlinie.deactivated);
    const produktlinieToActivate = activatedProduktlinien.find(
      produktlinie => produktlinie.produktName === Produktlinienname.KOMFORT,
    );
    if (produktlinieToActivate != null) {
      produktlinieToActivate.selected = true;
    } else if (activatedProduktlinien.length > 0) {
      activatedProduktlinien[0].selected = true;
    }
  }
}
